import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {ProjectRoleType, ProjectStepType} from '@frontend/shared-api';
import {ContributorFilterDropdownComponent} from '../contributor-filter-dropdown/contributor-filter-dropdown.component';
import {StepDotMenuComponent} from '../step-dot-menu/step-dot-menu.component';

@Component({
  selector: 'app-contributor-menu-bar',
  imports: [ContributorFilterDropdownComponent, StepDotMenuComponent],
  templateUrl: './contributor-menu-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContributorMenuBarComponent {
  readonly projectId = input.required<number>();
  readonly showAverageOption = input(false);
  readonly dotMenuTestId = input('step-dot-menu-button');
  readonly preselectedRole = input<ProjectRoleType>();
  readonly preselectedAccessiblePages = input<ProjectStepType[]>();

  readonly contributorSelected = output<string>();
}
